var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccDelImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H28C34.3513 0.5 39.5 5.64873 39.5 12V28C39.5 34.3513 34.3513 39.5 28 39.5H12C5.64873 39.5 0.5 34.3513 0.5 28V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    fill: "url(#paint0_linear_228_1407)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H28C34.3513 0.5 39.5 5.64873 39.5 12V28C39.5 34.3513 34.3513 39.5 28 39.5H12C5.64873 39.5 0.5 34.3513 0.5 28V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    stroke: "url(#paint1_linear_228_1407)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.19 10H15.81C12.17 10 10 12.17 10 15.81V24.18C10 27.83 12.17 30 15.81 30H24.18C27.82 30 29.99 27.83 29.99 24.19V15.81C30 12.17 27.83 10 24.19 10ZM23.76 23.76C23.7 24.61 23.63 25.67 21.71 25.67H18.29C16.38 25.67 16.3 24.61 16.24 23.76L15.93 19.8C15.91 19.54 16 19.29 16.17 19.1C16.34 18.91 16.59 18.81 16.84 18.81H23.16C23.41 18.81 23.66 18.92 23.83 19.1C24 19.29 24.09 19.54 24.07 19.79L23.76 23.76ZM24.8 17.82C24.78 17.82 24.76 17.82 24.74 17.82C23.7 17.72 22.75 17.65 21.84 17.61C20.62 17.55 19.4 17.53 18.17 17.58C17.57 17.61 16.96 17.65 16.36 17.71L15.27 17.82C15.25 17.82 15.22 17.82 15.2 17.82C14.85 17.82 14.55 17.56 14.52 17.2C14.48 16.83 14.76 16.49 15.13 16.46L16.22 16.35C16.65 16.31 17.07 16.28 17.5 16.26L17.58 15.79C17.66 15.29 17.81 14.33 19.31 14.33H20.7C22.21 14.33 22.36 15.32 22.43 15.8L22.51 16.28C23.26 16.32 24.03 16.38 24.87 16.46C25.25 16.5 25.52 16.83 25.49 17.21C25.45 17.56 25.15 17.82 24.8 17.82Z",
    fill: "#34D399"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_228_1407",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_228_1407",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 34.7917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccDelImg);
export default __webpack_public_path__ + "static/media/accDelImg.2f3d63d1dde76afe28e6a714a802e03c.svg";
export { ForwardRef as ReactComponent };